import { HeadingProps, PROP_MAP } from './interface';

import Jdstext from '@jds/react-generated-sdl/JDSText';
import { componentsMap } from '../../../generators/componentMap';
import { createComponent } from '@jds/react-engine';
import { withModifiedProps } from '../../../generators/modifyProps';

const Component = ({ children, ...props }: HeadingProps) => {
  return createComponent(
    Jdstext,
    {
      ...props,
      text: props.text || children
    },
    'JDSText',
    componentsMap
  );
};

export const Heading = withModifiedProps(Component, PROP_MAP);

Heading.defaultProps = {
  as: 'h1'
};
